import React from "react";
import icon from '../../../assets/icons/delete-bin-line.svg'
import icon2 from '../../../assets/icons/Vector (4).svg'
import { toast } from "react-toastify";

const ActionBar = ({ onReject, onApprove, id, hide }) => {



    return (
        <div className="flex w-full h-[60px] items-center justify-between px-4 py-2 bg-gray-100 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
                Req# {id}
            </span>
            <div className="flex gap-2 items-center">

                {hide === "pending" && (
                    <>
                        <button
                            onClick={onReject}
                            className="flex items-center bg-[white] w-[125px] h-[47px] gap-1 px-4 py-1 border-2 border-red-500 text-red-500 font-medium rounded-[10px] transition"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 15.5C3.85775 15.5 0.5 12.1423 0.5 8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5ZM8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM8 6.9395L10.121 4.81775L11.1823 5.879L9.0605 8L11.1823 10.121L10.121 11.1823L8 9.0605L5.879 11.1823L4.81775 10.121L6.9395 8L4.81775 5.879L5.879 4.81775L8 6.9395Z"
                                    fill="#DF1C41"
                                />
                            </svg>
                            Reject
                        </button>
                        <button
                            onClick={onApprove}
                            className="flex items-center w-[125px] h-[47px] gap-1 px-3 py-1 bg-[#2D9F75] text-white font-medium rounded-[10px] transition"
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.49956 12.3791L15.3936 5.48438L16.4548 6.54488L8.49956 14.5001L3.72656 9.72712L4.78706 8.66663L8.49956 12.3791Z"
                                    fill="white"
                                />
                            </svg>
                            Approve
                        </button>
                    </>
                )}

                {hide === "approved" && null}

                {hide === "rejected" && (
                    <button
                        onClick={onApprove}
                        className="flex items-center w-[125px] h-[47px] gap-1 px-3 py-1 bg-[#2D9F75] text-white font-medium rounded-[10px] transition"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.49956 12.3791L15.3936 5.48438L16.4548 6.54488L8.49956 14.5001L3.72656 9.72712L4.78706 8.66663L8.49956 12.3791Z"
                                fill="white"
                            />
                        </svg>
                        Approve
                    </button>
                )}


                {hide === "blocked" && (
                    <>
                        <button
                            onClick={() => {
                                toast.error("You need to unblock the profile first.");
                            }}
                            className="flex items-center bg-[white] w-[125px] h-[47px] gap-1 px-4 py-1 border-2 border-red-500 text-red-500 font-medium rounded-[10px] transition"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 15.5C3.85775 15.5 0.5 12.1423 0.5 8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5ZM8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM8 6.9395L10.121 4.81775L11.1823 5.879L9.0605 8L11.1823 10.121L10.121 11.1823L8 9.0605L5.879 11.1823L4.81775 10.121L6.9395 8L4.81775 5.879L5.879 4.81775L8 6.9395Z"
                                    fill="#DF1C41"
                                />
                            </svg>
                            Reject
                        </button>
                        <button
                            onClick={() => {
                                toast.error("You need to unblock the profile first.");
                            }}
                            className="flex items-center w-[125px] h-[47px] gap-1 px-3 py-1 bg-[#2D9F75] text-white font-medium rounded-[10px] transition"
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.49956 12.3791L15.3936 5.48438L16.4548 6.54488L8.49956 14.5001L3.72656 9.72712L4.78706 8.66663L8.49956 12.3791Z"
                                    fill="white"
                                />
                            </svg>
                            Approve
                        </button>
                    </>
                )}
            </div>

        </div>
    );
};

export default ActionBar;
